module.exports = __webpack_public_path__ + "static/media/pricing@1x.048c5ac7.mov";